import React, { useEffect, useState } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import landingCar from '../../assets/images/landing-car.png';
import { fetchCarMakes, fetchCarModels, fetchCarYears } from '../../services/api'
import { useHistory } from 'react-router';
import CarSelection from '../../components/CarSelection/CarSelection';

import './Landing.scss';
import ChristmasBanner2023Desktop from '../../assets/images/ChristmasBanner2023Desktop1.png';
import ChristmasBanner2023Mobile from '../../assets/images/ChristmasBanner2023Mobile.png';


window.dataLayer = window.dataLayer || [];


const LandingPage = (props)=>{
    const params = new URLSearchParams(window.location.search);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 700);
    const [mobileHeight, setMobileHeight] = useState(window.innerHeight);

    useEffect(()=>{
        params.get('tmpl') === 't2' ? document.body.classList.add('active-blue') : document.body.classList.remove('active-blue');
    },[]);

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 700);
            setMobileHeight(window.innerHeight)
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (<>
        <div className="landing-page-container">
            <div className="landing-wrapper">
                <Header className="transparent-background"></Header>
                <div className="landing-container container">
                    {/*{*/}
                    {/*    (params.get('tmpl')==='t2'  && ( isDesktop ?<img src={ChristmasBanner2023Desktop} style={{marginTop:"24px"}} className='christmas-banner-desktop'/>:<img src={ChristmasBanner2023Mobile} className='christmas-banner-mobile'/>))*/}


                    {/*}*/}
                    <div className="landing-top-content">
                        <div className="landing-content-container" style={(params.get('tmpl')==='t2' && isDesktop) ? {paddingBottom:"0px",marginTop:"-20px"}:(params.get('tmpl')==='t2' && isDesktop===false)?{padding:"0px"}:{paddingBottom:"none",marginTop:"none"}}>
                            <div className="header" style={(params.get('tmpl')==='t2'  && window.innerWidth<700 )?{fontSize:"22px",lineHeight:"normal"}:{}}>Search dealers in your location</div>
                            <div className="divider"></div>
                            <div className="sub-header">Finding the car of your dreams is quick and easy. From comfortable sedans to robust SUVs, luxury convertibles to spacious minivans, you can find everything right here.</div>
                        </div>
                        <div className="landing-car-container">
                            <img className="landing-car" src={landingCar} style={(params.get('tmpl')==='t2' && isDesktop)? {width:"677px",height:"329px",marginLeft:"30px"}:(isDesktop===false && mobileHeight<700)?{}:{}}></img>
                            <div className="car-background"></div>
                        </div>
                    </div>
                    <CarSelection 
                        sticky={true}
                        ctaClicked={(params)=>{
                            const make = params.get('make');
                            const model = params.get('model');
                            const year = params.get('year');
                            window.dataLayer.push({
                                'event': 'Get dealers',
                                'eventCallback': () => {
                                    window.location.href = `/deals?${params.toString()}`;
                                },
                                'eventTimeout': 2000,
                                'event_make': make,
                                'event_model': model,
                                'event_year': year,
                                'event_category': 'Landing car selection'
                            })
                        }}
                    >
                    </CarSelection>
                </div>
                
            </div>
            <Footer></Footer>
        </div>
    </>)
}
export default LandingPage;